import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Honeycomb from 'components/common/Honeycomb';
import HBox from 'components/common/HBox';
import { numberWithComma } from 'utils/number';
import SummaryBox from '../ReportBloodGlocose/SummaryBox';
import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import VBar from '../ReportBloodGlocose/VBar';


export default function InsulinSummary(props) {
  const {
    insulin_data,
    ...rest
  } = props;
  return (
    <HBox {...ex('InsulinSummary', rest)}>
      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('일평균 인슐린')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('전체'),
              value: numberWithComma(insulin_data.avg_insulin_amt),
              unit: 'U',
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('볼루스'),
              value: numberWithComma(insulin_data.avg_bolus_amt),
              unit: 'U',
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('기저'),
              value: numberWithComma(insulin_data.avg_giju_amt),
              unit: 'U',
            }}
          />
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('일별 인슐린')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('최대'),
              value: numberWithComma(insulin_data.avg_max_insulin_amt),
              unit: 'U',
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('최소'),
              value: numberWithComma(insulin_data.avg_min_insulin_amt),
              unit: 'U',
            }}
          />
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('일평균 기록')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('볼루스'),
              value: numberWithComma(insulin_data.avg_bolus_cnt),
              unit: '회',
            }}
          />
        </HBox>
      </Segment>
    </HBox>
  );
}
